/*
  Ebbrest: покупка (сборщик B). Подключается с defer из snippets/eb-head.liquid. Библиотек нет.

  1. Карточки версии и комплекта (blocks/eb-size-cards.liquid) работают поверх штатного выбора варианта Horizon.
     Тап по карточке нажимает штатную радиокнопку внутри <variant-picker>; запрос секции, галерею,
     id варианта в форме и липкую панель обновляет сама тема. В корзину мы ничего не шлём.
     Строку цены в блоке покупки и в липкой панели пишем сами в том же кадре, что и нажатие (writePrice):
     тема меняет её только после ответа сети (250-600 мс на стенде). Ответ темы приносит тот же текст.
  1a. Пока версия не выбрана, ?variant= из адреса убирается (stripVariant): комплект без версии не должен
     после перезагрузки превращаться в выбранную базовую версию.
  2. Пока версия не выбрана (data-eb-pending="true"), кнопка покупки и кнопка липкой панели называются
     «Choose a version», в корзину не кладут и прокручивают к карточкам. После выбора: «Add to cart · $299».
     Тема перерисовывает кнопки после каждой смены варианта, поэтому подписи возвращает MutationObserver,
     в том же кадре, что и перерисовка.
  3. Ссылки с data-eb-scroll="eb-loop" (первый экран главной) прокручивают к секции с таким классом.

  Если штатного выбора варианта в секции нет, карточки выключаются (data-eb-off) и тема работает как обычно.
*/
(function () {
  'use strict';

  if (window.__ebBuy) return;
  window.__ebBuy = true;

  var ROOT = '[data-eb-size-cards]';
  var MAIN_BUTTON = 'product-form-component add-to-cart-component button';
  var STICKY_BUTTON = '.sticky-add-to-cart__button';
  var states = [];
  var lastBuyClick = 0;

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function stateFor(node) {
    var section = node && node.closest ? node.closest('.shopify-section') : null;
    if (!section) return null;
    for (var i = 0; i < states.length; i++) {
      if (states[i].section === section && states[i].root.isConnected) return states[i];
    }
    return null;
  }

  /* Штатные радиокнопки одной опции. Ищем заново при каждом обращении: тема перерисовывает <variant-picker>. */
  function stockInputs(st, optionName) {
    var picker = st.section.querySelector('variant-picker');
    if (!picker || !optionName) return [];
    var all = picker.querySelectorAll('input[type="radio"]');
    var out = [];
    for (var i = 0; i < all.length; i++) {
      if (all[i].getAttribute('data-option-name') === optionName) out.push(all[i]);
    }
    return out;
  }

  function cardInputs(st, group) {
    return st.root.querySelectorAll('input[data-eb-card="' + group + '"]');
  }

  function checkedValue(inputs) {
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].checked) return inputs[i].value;
    }
    return null;
  }

  function findVariant(st, model, setup) {
    for (var i = 0; i < st.variants.length; i++) {
      var v = st.variants[i];
      if (v.model === model && (!st.setupName || v.setup === setup)) return v;
    }
    return null;
  }

  /* Первый непустой текстовый узел: у кнопки темы подпись лежит голым текстом рядом с иконкой. */
  function ownTextNode(el) {
    if (!el) return null;
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node.nodeType === 3 && node.nodeValue.trim()) return node;
    }
    return null;
  }

  function setText(node, text) {
    if (node && node.nodeValue.trim() !== text) node.nodeValue = text;
  }

  /*
    Строка цены темы (<product-price> в блоке покупки и цена липкой панели). Версия выбрана: цена варианта.
    Не выбрана: наименьшая цена среди версий для текущего комплекта; слово From ставит CSS по data-eb-from,
    и только если цены версий различаются. Текст берётся из разметки сервера (v.price), формат тот же, что у темы.
  */
  function writePrice(st, current, setup) {
    var low = current;
    var varies = false;
    if (!low) {
      for (var i = 0; i < st.variants.length; i++) {
        var v = st.variants[i];
        if (st.setupName && v.setup !== setup) continue;
        if (low && v.cents !== low.cents) varies = true;
        if (!low || v.cents < low.cents) low = v;
      }
    }
    var from = varies ? 'true' : 'false';
    if (st.root.getAttribute('data-eb-from') !== from) st.root.setAttribute('data-eb-from', from);
    if (!low || !low.price) return;
    var nodes = st.section.querySelectorAll('.product-details product-price .price bdi, .sticky-add-to-cart__price .price bdi');
    for (var n = 0; n < nodes.length; n++) {
      if (nodes[n].textContent.trim() !== low.price) nodes[n].textContent = low.price;
    }
  }

  /* Состояние штатного выбора переносим на карточки: комплект всегда, версию только после выбора. */
  function syncFromStock(st) {
    var groups = [
      ['setup', st.setupName, true],
      ['model', st.modelName, st.chosen],
    ];
    for (var g = 0; g < groups.length; g++) {
      if (!groups[g][1]) continue;
      var value = checkedValue(stockInputs(st, groups[g][1]));
      var cards = cardInputs(st, groups[g][0]);
      for (var i = 0; i < cards.length; i++) {
        var on = groups[g][2] && value !== null && cards[i].value === value;
        if (cards[i].checked !== on) cards[i].checked = on;
      }
    }
  }

  function render(st) {
    if (st.off || !st.root.isConnected) return;

    syncFromStock(st);

    var model = st.chosen ? checkedValue(cardInputs(st, 'model')) : null;
    var setup = st.setupName ? checkedValue(cardInputs(st, 'setup')) : '';
    var pending = !st.chosen || model === null;
    var pendingAttr = pending ? 'true' : 'false';
    if (st.root.getAttribute('data-eb-pending') !== pendingAttr) st.root.setAttribute('data-eb-pending', pendingAttr);

    /* карточки: отметка, цена версии для текущего комплекта, «нет в наличии» */
    var cards = st.root.querySelectorAll('input[data-eb-card]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i].closest('label');
      if (!card) continue;
      card.classList.toggle('is-selected', cards[i].checked);
      if (cards[i].getAttribute('data-eb-card') !== 'model') continue;
      var v = findVariant(st, cards[i].value, setup);
      var priceNode = card.querySelector('[data-eb-card-price]');
      var soldNode = card.querySelector('[data-eb-card-soldout]');
      if (priceNode && v && priceNode.textContent.trim() !== v.price) priceNode.textContent = v.price;
      if (soldNode) soldNode.hidden = !v || v.available;
      card.classList.toggle('is-soldout', !v || !v.available);
    }

    /* кнопка покупки. Выключенную (нет в наличии) не трогаем: там текст темы. */
    var current = pending ? null : findVariant(st, model, setup);
    writePrice(st, current, setup);
    var main = st.section.querySelector(MAIN_BUTTON);
    var label = st.addLabel;
    if (pending) label = st.chooseLabel;
    else if (st.priceOnButton && current && current.available) label = st.addLabel + ' · ' + current.price;
    if (main && !main.disabled) setText(ownTextNode(main), label);

    /* липкая панель: слева версия и цена одной строкой, на кнопке та же подпись с ценой, что и на основной */
    var sticky = st.section.querySelector(STICKY_BUTTON);
    if (sticky && !sticky.disabled) {
      var holder = sticky.querySelector('.add-to-cart-text__content > span');
      if (holder) {
        if (holder.textContent.trim() !== label) holder.textContent = label;
      }
    }
    var line = st.section.querySelector('.sticky-add-to-cart__title');
    if (line) {
      var lineText = pending ? st.brand : model + (setup ? ' · ' + setup : '');
      if (line.textContent.trim() !== lineText) line.textContent = lineText;
    }

    stripVariant(st);
    queueHeight(st);
  }

  /*
    Версия не выбрана, а комплект уже нажат: тема пишет в адрес ?variant= базовой версии. После перезагрузки
    или возврата из корзины сервер счёл бы её выбранной. Пока версии нет, параметр из адреса убираем.
    Ссылку с ?variant=, по которой пришли (реклама, письмо), это не трогает: там версия выбрана сервером.
  */
  function stripVariant(st) {
    if (st.chosen || !window.history || !history.replaceState) return;
    try {
      var url = new URL(location.href);
      if (!url.searchParams.has('variant')) return;
      url.searchParams.delete('variant');
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    } catch (error) {}
  }

  /* Высота липкой панели для сцены ночи: её карточка не должна уходить под панель (sections/eb-night.liquid). */
  function stickyHeight(st) {
    var bar = st.section.querySelector('.sticky-add-to-cart__bar');
    var h = 0;
    if (bar && window.matchMedia && window.matchMedia('(max-width: 749px)').matches) h = Math.round(bar.offsetHeight);
    if (h !== st.barHeight) {
      st.barHeight = h;
      document.documentElement.style.setProperty('--eb-sticky-bar', h + 'px');
    }
  }

  /* Замер высоты читает вёрстку, а render теперь зовётся на каждую пачку мутаций секции: замер раз в кадр. */
  function queueHeight(st) {
    if (st.heightQueued) return;
    st.heightQueued = true;
    requestAnimationFrame(function () {
      st.heightQueued = false;
      if (st.root.isConnected) stickyHeight(st);
    });
  }

  function schedule(st) {
    if (st.queued) return;
    st.queued = true;
    requestAnimationFrame(function () {
      st.queued = false;
      render(st);
    });
  }

  /* «Choose a version»: к карточкам версии, фокус на первую, короткая подсветка. */
  function nudge(st) {
    var group = st.root.querySelector('[data-eb-group="model"]') || st.root;
    group.scrollIntoView({ block: 'center', behavior: reducedMotion() ? 'auto' : 'smooth' });
    var first = cardInputs(st, 'model')[0];
    if (first) first.focus({ preventScroll: true });
    st.root.classList.add('is-nudged');
    clearTimeout(st.nudgeTimer);
    st.nudgeTimer = setTimeout(function () {
      st.root.classList.remove('is-nudged');
    }, 1400);
  }

  function turnOff(st) {
    st.off = true;
    st.root.setAttribute('data-eb-off', '');
    st.root.setAttribute('data-eb-pending', 'false');
    if (st.observer) st.observer.disconnect();
    /* инлайн-скрипт блока мог уже переименовать кнопку: возвращаем подпись темы */
    var main = st.section.querySelector(MAIN_BUTTON);
    var node = ownTextNode(main);
    if (node && node.nodeValue.trim() === st.chooseLabel) node.nodeValue = st.addLabel;
  }

  function init(root) {
    var section = root.closest('.shopify-section');
    if (!section) return;

    for (var i = states.length - 1; i >= 0; i--) {
      if (states[i].root === root) return;
      if (!states[i].root.isConnected) {
        if (states[i].observer) states[i].observer.disconnect();
        states.splice(i, 1);
      }
    }

    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-eb-variants]').textContent) || [];
    } catch (error) {
      variants = [];
    }

    var st = {
      root: root,
      section: section,
      variants: variants,
      modelName: root.getAttribute('data-eb-model-option'),
      setupName: root.getAttribute('data-eb-setup-option') || '',
      chooseLabel: root.getAttribute('data-eb-choose-label') || 'Choose a version',
      brand: root.getAttribute('data-eb-brand') || '',
      barHeight: -1,
      addLabel: root.getAttribute('data-eb-add-label') || 'Add to cart',
      priceOnButton: root.getAttribute('data-eb-price-on-button') !== 'false',
      chosen: root.getAttribute('data-eb-pending') !== 'true',
      off: false,
      queued: false,
      observer: null,
      nudgeTimer: 0,
    };
    states.push(st);

    /* Карточкам нужен штатный выбор кнопками. Нет его (или стоит выпадающий список): выключаемся. */
    var modelStock = stockInputs(st, st.modelName);
    var setupStock = st.setupName ? stockInputs(st, st.setupName) : [null];
    if (!variants.length || !modelStock.length || !setupStock.length) {
      turnOff(st);
      if (window.console) console.warn('[eb-buy] variant-picker with buttons not found, size cards are off');
      return;
    }

    root.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.getAttribute || !input.getAttribute('data-eb-card')) return;
      var isModel = input.getAttribute('data-eb-card') === 'model';
      if (isModel) st.chosen = true;
      /* тема меняет адрес после своего запроса секции: проверяем ещё раз, когда он точно прошёл */
      else if (!st.chosen) setTimeout(function () { stripVariant(st); }, 1200);
      var stock = stockInputs(st, isModel ? st.modelName : st.setupName);
      for (var k = 0; k < stock.length; k++) {
        if (stock[k].value === input.value) {
          /* click() сам ставит checked и шлёт change: его слушает <variant-picker> темы */
          if (!stock[k].checked) stock[k].click();
          break;
        }
      }
      render(st);
    });

    /* Тема морфит кнопку, липкую панель и сам выбор варианта после каждого запроса секции. */
    st.observer = new MutationObserver(function () {
      /* без ожидания кадра: иначе после морфа темы кнопка на 1-3 кадра оставалась с подписью темы, без цены.
         Свои записи render делает только при расхождении, поэтому второй вызов наблюдателя ничего не меняет. */
      render(st);
    });
    st.observer.observe(section, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'checked', 'data-current-checked'],
    });

    render(st);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  /*
    Перехват нажатия до темы. Horizon ловит клики на document в фазе capture, поэтому слушаем window:
    его capture-слушатели срабатывают раньше. Синтетический click() липкой панели по основной кнопке
    тоже проходит через window и сюда попадает.
  */
  window.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var button = target.closest(MAIN_BUTTON + ', ' + STICKY_BUTTON);
      if (button) {
        if (button.closest('product-card, quick-add-dialog')) return;
        /* Двойное нажатие: Horizon кнопку на время запроса не глушит, два быстрых нажатия кладут два товара
           (проверено 13.10.2026 на 390 px). Второе настоящее нажатие в течение секунды гасим. Синтетический
           click() липкой панели по основной кнопке не трогаем (isTrusted false). */
        if (event.isTrusted) {
          var now = Date.now();
          if (now - lastBuyClick < 1000) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
          lastBuyClick = now;
        }
        var st = stateFor(button);
        if (!st || st.off || st.root.getAttribute('data-eb-pending') !== 'true') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        nudge(st);
        return;
      }

      var link = target.closest('[data-eb-scroll]');
      if (link) {
        var name = link.getAttribute('data-eb-scroll');
        var scene = name ? document.querySelector('.' + name.replace(/[^a-z0-9_-]/gi, '')) : null;
        if (!scene) return;
        event.preventDefault();
        scene.scrollIntoView({ block: 'start', behavior: reducedMotion() ? 'auto' : 'smooth' });
      }
    },
    true
  );

  /* Страховка: форму не отправить и клавишей Enter, пока версия не выбрана. */
  window.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
      if (form.closest('product-card, quick-add-dialog')) return;
      var st = stateFor(form);
      if (!st || st.off || st.root.getAttribute('data-eb-pending') !== 'true') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      nudge(st);
    },
    true
  );

  /* Выбор сменили не карточкой (штатный выбор, история браузера): подтягиваем карточки. */
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest || !target.closest('variant-picker')) return;
    var st = stateFor(target);
    if (st && !st.off) schedule(st);
  });

  window.addEventListener('pageshow', function () {
    for (var i = 0; i < states.length; i++) schedule(states[i]);
  });

  /* Редактор темы перерисовывает секцию целиком. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }
})();
